import { FunctionComponent, HTMLAttributes, RefObject, CSSProperties } from 'react';

import { useModifiers } from '@pp/core';
import styles from './BettingGrid.module.css';

export interface BettingGridProps extends HTMLAttributes<HTMLDivElement> {
  isCollapsed: boolean;
  gridRef: RefObject<HTMLDivElement>;
  targetScale: number | null;
  targetShift?: number;
  hidden?: boolean;
  planted?: boolean;
}

export const BettingGrid: FunctionComponent<BettingGridProps> = ({
  isCollapsed,
  targetScale,
  targetShift,
  gridRef,
  className,
  children,
  hidden,
  planted,
  ...rest
}) => {
  const mods: string = useModifiers(styles, 'bettingGrid', {
    collapsed: isCollapsed,
    hidden: hidden || !targetScale,
  });

  return (
    <div
      className={`${styles.bettingGrid} ${mods} ${className || ''}`}
      ref={gridRef}
      style={{ '--targetScale': `${targetScale}`, '--targetShift': `${targetShift}px` } as CSSProperties}
      {...rest}
    >
      {children}
    </div>
  );
};
